import React, {Component} from "react"

class TeamPagination extends Component {
    render() {
        return (
            <div>

            </div>
        )
    }
}

export default TeamPagination


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/teams/TeamPagination.js